import Cookies from 'js-cookie'
import EventBus from 'event_bus'
import escape from 'lodash-es/escape'

export default class SocialFeed {
  constructor ($element, selector) {
    this.$element = $element
    this.url = $element.data('url')
    this.type = $element.data('type')

    if (this.getSocialOptin()) {
      this.render()
    } else {
      this.attach(selector)
    }
  }

  attach (selector) {
    this.$element.find(selector).on('click', this.onClick.bind(this))

    EventBus.on('social-optin', this.render.bind(this))
  }

  onClick () {
    this.setSocialOptin()

    EventBus.trigger('social-optin', true)
  }

  render () {
    var markup

    if (this.type === 'FACEBOOK') {
      markup = this.facebookMarkup()
    } else if (this.type === 'TWITTER') {
      markup = this.twitterMarkup()
    }

    this.$element.html(markup)
  }

  twitterMarkup () {
    return `<a class="twitter-timeline" data-height="500" href="${escape(this.url)}" />
      <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>`
  }

  facebookMarkup () {
    const width = Math.min(this.$element.width(), 500)
    const url = `https://www.facebook.com/plugins/page.php?href=${escape(this.url)}&tabs=timeline&width=${width}&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId`

    return `<iframe
        src="${url}"
        width=500
        height="500"
        class="widgets-social_feed__facebook"
        scrolling="no"
        frameborder="0"
        allowTransparency="true"
        allow="encrypted-media"
      /> `
  }

  getSocialOptin () {
    return Cookies.get('social-optin')
  }

  setSocialOptin () {
    Cookies.set('social-optin', true, { expires: 365 })
  }
}

$(() => {
  $('.widgets-social_feed').each((index, Element) => {
    new SocialFeed($(Element), '.js-widgets-social_feed__button')
  })
})
